import { render, staticRenderFns } from "./my-upload-hw.vue?vue&type=template&id=ad4b2a4e&scoped=true&"
import script from "./my-upload-hw.vue?vue&type=script&lang=js&"
export * from "./my-upload-hw.vue?vue&type=script&lang=js&"
import style0 from "./my-upload-hw.vue?vue&type=style&index=0&id=ad4b2a4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4b2a4e",
  null
  
)

export default component.exports